import {Utils} from '../underscore-extensions';

class PlanAnimation implements ng.IComponentController {
    private static Animations = _.object(['free', 'pro', 'business'].map(plan =>
        [plan, `https://videos.animatron.com/pricing/${plan}${options.retina ? '_2x' : ''}.mp4`]
    ));
    private plan: string;
    private url: string;
    private width: number;
    private height: number;
    private inited: boolean;

    constructor(private $rootScope: ng.IRootScopeService,
                private $element: ng.IAugmentedJQuery) {}

    $onInit() {
        if (options.handHeld) return;
        Utils.rAF(() => {
            const {width, height} = this.$element[0].parentElement.getBoundingClientRect();

            this.url      = PlanAnimation.Animations[this.plan.toLowerCase()];
            this.width    = width;
            this.height   = height;
            const video   = <HTMLVideoElement>this.$element[0].querySelector('video');
            const safe    = (f: 'pause' | 'play') => video && _.isFunction(video[f]) && video[f]();
            this.$rootScope.$on(`onScreen:${this.url}`, () => safe('play'));
            this.$rootScope.$on(`notOnScreen:${this.url}`, () => safe('pause'));
            this.inited = true;
        });
    }

    $onDestroy() {
        _.isFunction(window.stop) && window.stop();
    }
}


angular.module('animatronApp.planAnimation', []).component('planAnimation', {
    bindings: {
        plan: '@'
    },
    controller: PlanAnimation,
    template: `<div ng-if="::$ctrl.inited" id="player-{{::$ctrl.plan.toLowerCase()}}" class="animation">
                    <video width="{{::$ctrl.width}}" height="{{::$ctrl.height}}" 
                           ng-if="::!$root.options.handHeld"
                           preload autoplay muted loop playsinline webkit-playsinline>
                        <source ng-src="{{::$ctrl.url}}" type="video/mp4">
                        <source ng-src="{{::$ctrl.url.replace('mp4', 'webm')}}" type="video/webm">
                    </video>
                    <div id="{{::$ctrl.url}}" class="middle" is-on-screen></div>
               </div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/PlanAnimation.ts